import React, { useRef, useEffect } from 'react';
import { Line, Transformer, Group } from 'react-konva';

export default function DrawingElement({ 
  element, 
  isSelected, 
  isBeingEdited,
  onSelect, 
  onDragEnd,
  onTransformEnd,
  onUpdate,
  canEdit 
}) {
  const lineRef = useRef(null);
  const transformerRef = useRef(null);
  
  const props = element.properties || {};
  const points = props.points || [];
  const stroke = props.stroke || '#000000';
  const strokeWidth = props.strokeWidth || 2;
  
  // Attach transformer when selected
  useEffect(() => {
    if (isSelected && transformerRef.current && lineRef.current) {
      transformerRef.current.nodes([lineRef.current]);
      transformerRef.current.getLayer()?.batchDraw();
    }
  }, [isSelected]);
  
  if (points.length < 4) return null;

  const selectionStroke = isSelected ? '#3B82F6' : (isBeingEdited ? isBeingEdited.color : stroke);

  return (
    <>
      <Line
        ref={lineRef}
        x={element.x}
        y={element.y}
        points={points}
        stroke={selectionStroke}
        strokeWidth={strokeWidth}
        tension={props.tension || 0.5}
        lineCap={props.lineCap || 'round'}
        lineJoin={props.lineJoin || 'round'}
        draggable={canEdit}
        onClick={(e) => onSelect(element.id, e)}
        onTap={(e) => onSelect(element.id, e)}
        onDragStart={(e) => {
          e.cancelBubble = true;
        }}
        onDragEnd={(e) => {
          e.cancelBubble = true;
          onDragEnd(element.id, { x: e.target.x(), y: e.target.y() });
        }}
        onTransformEnd={() => {
          const node = lineRef.current;
          if (!node) return;
          
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          
          // Scale the points
          const scaledPoints = points.map((p, i) => i % 2 === 0 ? p * scaleX : p * scaleY);
          
          node.scaleX(1);
          node.scaleY(1);
          
          onTransformEnd?.(element.id, {
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            properties: { ...props, points: scaledPoints }
          });
        }}
        hitStrokeWidth={Math.max(20, strokeWidth + 15)}
      />
      
      {isSelected && canEdit && (
        <Transformer
          ref={transformerRef}
          enabledAnchors={['middle-left', 'middle-right', 'top-center', 'bottom-center']}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 10 || newBox.height < 10) {
              return oldBox;
            }
            return newBox;
          }}
          rotateEnabled={true}
        />
      )}
    </>
  );
}
